class InputSuggestionCache {
  constructor (cacheSize = 50) {
    this.cache = [];
    this.cacheSize = cacheSize;
  }
  clear () {
    this.cache = [];
  }
  get (key) {
    const index = this.getCacheIndex(key);
    return index >= 0 ? this.cache[index][this.normalizeKey(key)] : [];
  }
  getCacheIndex (key) {
    return this.cache.findIndex(
      elem => Object.prototype.hasOwnProperty.call(elem, this.normalizeKey(key))
    );
  }
  hasCacheOf (key) {
    const index = this.cache.findIndex(
      elem => Object.prototype.hasOwnProperty.call(elem, this.normalizeKey(key))
    );
    return index >= 0;
  }
  normalizeKey (key) {
    return key.trim().toLowerCase();
  }
  set (key, data) {
    const index = this.getCacheIndex(key);
    if (index >= 0) {
      this.cache.splice(index, 1);
    }
    this.cache.push({ [this.normalizeKey(key)]: data });

    if (this.cache.length > this.cacheSize) {
      this.cache.splice(0, 1);
    }
  }
}

function getArrayIndexById (array, id) {
  if (id === null) {
    return null;
  }

  const index = array.findIndex(elem => elem.id === id);
  return index < 0 ? null : index;
}

export {
  InputSuggestionCache,
  getArrayIndexById,
};
